import { Project as ProjectModel } from '@material-bank/projects-api';
import { getUserAttributes, TIER_13_GROUP_ID } from './customer';
import { LocalStorageKey } from './localStorage';

export interface Project {
  project_id: number;
  updated_at: string;
  phase_name: string;
  phase_id: number;
  project_title: string;
  created_at: string;
  last_time_used: string;
  customer_id: number;
  isShared?: boolean;
  is_archived?: boolean;
  project_location: string;
  project_type: string | number;
  project_details: string;
  unread_messages?: number;
  phase_updated_at?: string;
  externalId?: number;
}

export interface NewProject {
  customer_id?: number;
  project_location: string;
  project_title: string;
  project_type: string;
  project_details?: string;
  phase_id?: number;
}

export interface ProjectType {
  value: string;
  label: string;
}

export interface ProjectPhase {
  created_at: string;
  phase_group: string;
  phase_id: number;
  phase_name: string;
  sort_order: string;
  updated_at: string;
}

export interface ProjectLocation {
  id: string;
  name: string;
}

export type StructuredProject = ProjectModel & {
  id: number;
  label: string;
};

export const updateSelectProjectTimestamp = () => {
  localStorage.setItem(
    LocalStorageKey.SELECT_PROJECT_TIMESTAMP,
    String(Date.now()),
  );
};

export const getSelectProjectTimestamp = () => {
  return JSON.parse(
    localStorage.getItem(LocalStorageKey.SELECT_PROJECT_TIMESTAMP) ?? '0',
  );
};

export const shouldTriggerProjectSelectionDialog = () => {
  const selectProjectTimestamp = getSelectProjectTimestamp();
  const userData = getUserAttributes();
  const isTier13 = userData?.groupId === TIER_13_GROUP_ID;
  const currentTimestamp = Date.now();

  if (isTier13) {
    return false;
  }

  return currentTimestamp - selectProjectTimestamp > 86400000; // 24 hours
};

export const findProjectWithTypeOther = (projectTypes: ProjectType[]) => {
  return projectTypes.find((projectType) => projectType.label === 'Other');
};
